import React from 'react';
import styled from 'styled-components';
import { SellerImage } from '../atoms/sellerImage';
import { SellerLocation } from '../atoms/sellerLocation';
import { SellerName } from '../atoms/sellerName';
import { SellerNewStore } from '../atoms/sellerNewStore';

interface SellerInfoProps {
  image: string;
  name: string;
  location: string;
  hasBadgeSalesVolume: boolean;
}

export const SellerInfo = ({ image, name, location, hasBadgeSalesVolume }: SellerInfoProps) => (
  <Wrapper>
    <TextContent>
      {!hasBadgeSalesVolume && <SellerNewStore />}
      <SellerName name={name} />
      {!!location && <SellerLocation location={location} />}
    </TextContent>
    <SellerImage imageUrl={image} />
  </Wrapper>
);

const Wrapper = styled.div`
  width: 100%;
  min-height: 64px;
  background-color: #fafafa;
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TextContent = styled.div`
  padding: 8px 0;
`;
